var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"bottom":"","max-width":"300"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-icon',_vm._g({attrs:{"tabindex":"0","role":"button","aria-label":_vm.helpLabel}},on),[_vm._v("help_outline")])]}}])},[_c('span',[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }